export const DEFAULT_FARE = {
    maxDistance: 0,
    pricePerDistance: 0,
    pricePerMinute: 0
}

export const DEFAULT_PEAK_HOUR_CHARGES = {
    fromTime: "07:00",
    toTime: "09:00",
    pricePerDistance: 0,
    pricePerMinute: 0
}

export const DEFAULT_VALUES = {
    cancellation: {
        noShow: {
            enabledMinutes: 0,
            maxNoPenaltyCount: 0,
            penaltyFee: 0
        },
        late: {
            enabledMinutes: 0,
            maxNoPenaltyCount: 0,
            penaltyFee: 0
        }
    },
    fares: [DEFAULT_FARE],
    peakHourCharges: [DEFAULT_PEAK_HOUR_CHARGES],
    pinkProgramCharges: {
        pricePerDistance: 0,
        pricePerMinute: 0
    },
    petServiceCharges: {
        pricePerDistance: 0,
        pricePerMinute: 0
    }
}
